import * as React from "react";
import * as Modal from "react-modal";
import { toast } from "react-toastify";

export default class Edit extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      columns: [],
      exportModal: false,
    };
  }
  getCSV = async () => {
    try {
      const response = await fetch("users/export", {
        method: "post",
        body: JSON.stringify({
          international: this.props.international,
          columns: this.state.columns,
        }),
      });
      if (response) {
        this.setState({ exportModal: false });
        const data = await response.text();
        this.loadCSV(data);
      }
    } catch (err) {
      toast.error(err.message);
    }
  };

  loadCSV = (data: any) => {
    const loadCSVButton = document.createElement("a");
    loadCSVButton.setAttribute("download", "users.csv");
    loadCSVButton.setAttribute("href", `data:text/csv;,${data}`);
    loadCSVButton.style.display = "none";
    document.body.appendChild(loadCSVButton);
    loadCSVButton.click();
    document.body.removeChild(loadCSVButton);
  };
  public render() {
    return (
      <div style={{display: "inline-block"}}>
        <button
          onClick={() => {
            this.setState({
              exportModal: true,
            });
          }}
          style={{ width: "70px" }}
        >
          ייצוא
        </button>
        <Modal isOpen={this.state.exportModal} className="newUser-modal">
          <a
            className="fa fa-times"
            onClick={() => {
              this.setState({
                exportModal: false,
              });
            }}
          ></a>
          <div className="scroll">
            <select
              className="multiple"
              style={{ height: "500px" }}
              onChange={(e: any) => {
                let value = e.target.value;

                value = Array.from(
                  e.target.selectedOptions,
                  (option: any) => option.value
                );

                this.setState({ columns: value });
              }}
              name="columns"
              multiple
            >
              <option value="name">שם</option>
              <option value="phone">טלפון</option>
              <option value="city">עיר</option>
              <option value="categoryId">קטגוריה</option>
              <option value="birthDate">גיל</option>
              <option value="sex">מין</option>
              <option value="type">סוג</option>
              <option value="socialUrl">קישור</option>
              <option value="followers">עוקבים</option>
              <option value="agency">סוכנות</option>
              <option value="engagementPercentage">אחוז מעורבות</option>
              <option value="viewsPercentage">אחוז צפיה</option>
              <option value="storyPrice">מחיר סטורי</option>
              <option value="feedPrice">מחיר פיד</option>
              <option value="subCategory">תת קטגוריה</option>
              <option value="teenFollowers">18-25</option>
              <option value="youngFollowers">25-35</option>
              <option value="adultFollowers">35-45</option>
              <option value="israeliPercentage">אחוז ישראלים</option>
              <option value="fakePercentage">אחוז מזויפים</option>
              <option value="malePercentage">אחוז גברים</option>
              <option value="femalePercentage">אחוז נשים</option>
              <option value="insurance">קופ״ח</option>
              <option value="lastScan">סריקה אחרונה</option>
            </select>
            <button
              className="submit"
              onClick={() => {
                this.getCSV();
              }}
            >
              ייצוא
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/users/Export.tsx